import type {
  InternalLinkType,
  ExternalLinkType,
  SamePageLinkType,
  BreadCrumbLink,
} from '@/types/app'

export const isInternalLinkType = (
  value: InternalLinkType | ExternalLinkType | SamePageLinkType
): value is InternalLinkType => {
  return 'to' in value
}

export const isExternalLinkType = (
  value: InternalLinkType | ExternalLinkType
): value is ExternalLinkType => {
  return 'href' in value
}

export const isSamePageLinkType = (
  value: BreadCrumbLink
): value is SamePageLinkType => {
  return 'href' in value && value.href === ''
}
